import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import { personaCardBehavior, } from 'owa-persona/lib/components/PersonaCardBehavior';
import * as React from 'react';
var styles = require('./SearchBoxPillWell.scss');
var PersonaPill = /** @class */ (function (_super) {
    tslib_1.__extends(PersonaPill, _super);
    function PersonaPill() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PersonaPill.prototype.render = function () {
        return (React.createElement("div", { className: styles.personaPill, onMouseEnter: this.props.onPersonaCardBehaviorMouseEnter, onMouseLeave: this.props.onPersonaCardBehaviorMouseLeave },
            React.createElement(PersonaControl, { name: this.props.name, emailAddress: this.props.emailAddress, size: PersonaSize.extraExtraSmall }),
            React.createElement("div", { className: styles.personaPillNameText }, this.props.name)));
    };
    PersonaPill = tslib_1.__decorate([
        personaCardBehavior,
        observer
    ], PersonaPill);
    return PersonaPill;
}(React.Component));
export default PersonaPill;
//# sourceMappingURL=PersonaPill.js.map